import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
} from "../../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
} from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import {
  setCurrentAgentMortgageProperty,
} from "../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";
import { fullName } from "../../../app/utils";
import { currentAgentApplicationSelector } from "../../../redux/selector/collectorApplicationSelector";
import TopNavigationBar from "../../TopNavigationBar";

const MORTGAGE_APPLICATION_ASSOCIATE = "userApplicationReviewComplete";

const applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;
const applicationMode = APPLICATION_MODE_NEW;

export const AssociateBrokerConfirmation = (props) => {
  const dispatch = useDispatch();
  const [confirmCheck, setConfirmCheck] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const {businessName,principalBrokerData} = useSelector(state => ({
    businessName : state.primaryAgencyApplication.application?.businessLicenceData?.businessName ?? "the Mortgage Brokerage",
    principalBrokerData : state.primaryAgencyApplication.application?.businessLicenceData?.personData ?? {}
  }))

  const agentApplication = useSelector(currentAgentApplicationSelector); 
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION
  const isAssociateBroker = (licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION)
  const agentApplicationData = agentApplication?.businessLicenceData?.personData ?? {}

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              id="associate-confirmation-header"
              header="Confirmation"
            />
            <div style={{ marginBottom: "35px" }}>
              <Paragraph
                style={{ margin: "0 0 0 0" }}
                id="associate-confirmation-text"
                text={[
                  `As a Principal Broker for <b>${businessName}</b>, I <b>${fullName(principalBrokerData)}</b> confirm, that ${isAssociateBroker ? 'Associate' : ''} Mortgage Broker applicant <b>${fullName(agentApplicationData)}</b> has read and understood the Mortgage Regulation Act and its regulations and agrees to be bound by their provisions.`
                  ]}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-associate-confirmation-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText="Yes, I confirm"
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Continue"}
              onClick={() => {
                if (!confirmCheck) {
                  setShowValidationError(true);
                  return;
                }

                setShowValidationError(false);

                // Set MORTGAGE PROP value
                dispatch(
                  setCurrentAgentMortgageProperty({
                    key: MORTGAGE_APPLICATION_ASSOCIATE,
                    value: true,
                  })
                );

                // On to the next item
                dispatch(
                  saveBusinessLicenceApplicationData(
                    applicationType,
                    applicationMode
                  )
                )
                  .then((data) => {
                    if(agentApplication?.businessLicenceData.licenceUpgradeApplicationId) {
                      //go to payment
                      dispatch(
                        push({
                          pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_PAYMENT_PREVIEW}`
                        })
                      );
                    }
                    else {
                      dispatch(
                        push({
                          pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ADD_BROKERS_TO_BROKERAGE}`,
                          state: { MRA_BROKER_ASSOCIATE: true },
                        })
                      );
                    }
                  })
                  .catch((err) => {
                    setApplicationSaveError(true);
                  });
              }}
            />
            {(showValidationError || applicationSaveError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
